import * as React from "react";
import Svg, { Path, Rect, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});
cssInterop(Rect, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: {
      fill: true,
      stroke: true,
    },
  },
});

type AddSlotIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
  rectFillClassName?: string;
  rectStrokeClassName?: string;
};

function AddSlotIcon({
  className,
  pathClassName = "stroke-white",
  rectFillClassName = "fill-white",
  rectStrokeClassName = "stroke-gray-200",
  ...props
}: AddSlotIconProps) {
  return (
    <Svg
      width={32}
      height={30}
      viewBox="0 0 32 30"
      fill="none"
      className={className}
      {...props}
    >
      <Rect
        x={0.468748}
        y={0.468748}
        width={30.9374}
        height={29.0624}
        rx={8.11295}
        strokeWidth={0.937496}
        className={rectStrokeClassName}
      />
      <Path
        d="M15.935 8.582v12.26M22.066 14.71H9.806"
        strokeWidth={1.40624}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default AddSlotIcon;
